import { Injectable } from "@nestjs/common";
import { DownTimeReasonDto } from "./downtimereason.dto";
import { DownTimeReason } from "./downtimereason.entity";

@Injectable()
export class DownTimeReasonAdapter {
  
    public convertDtoToEntity(downTimeReasonDto: DownTimeReasonDto,  isUpdate: boolean = false ): DownTimeReason {
      const downtime = new DownTimeReason();
      downtime.downtimereasonId=downTimeReasonDto.downtimereasonId;
      downtime.downtimeReason=downTimeReasonDto.downtimeReason;
      downtime.downtimestatus=downTimeReasonDto.downtimestatus;
      downtime.sla=downTimeReasonDto.sla;
      
      
      // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
      downtime.isActive=downTimeReasonDto.isActive==undefined?true:downTimeReasonDto.isActive;
      if (isUpdate) {
        downtime.updatedUser = downTimeReasonDto.updatedUser;
      } else {
        downtime.isActive = true;
          downtime.createdUser = downTimeReasonDto.createdUser;
      }
     return downtime;
    }

    public convertEntityToDto(downTimeReasonObject: DownTimeReason): DownTimeReasonDto {
        const downtimereasonDto= new DownTimeReasonDto;
        downtimereasonDto.downtimereasonId=downTimeReasonObject.downtimereasonId;
        downtimereasonDto.downtimeReason = downTimeReasonObject.downtimeReason;
        downtimereasonDto.downtimestatus=downTimeReasonObject.downtimestatus;
        downtimereasonDto.isActive = downTimeReasonObject.isActive;
        downtimereasonDto.createdAt = downTimeReasonObject.createdAt;
        downtimereasonDto.updatedAt = downTimeReasonObject.updatedAt;
        downtimereasonDto.createdUser = downTimeReasonObject.createdUser;
        downtimereasonDto.updatedUser = downTimeReasonObject.updatedUser;
        downtimereasonDto.versionFlag = downTimeReasonObject.versionFlag;
        downtimereasonDto.sla=downTimeReasonObject.sla;
        return downtimereasonDto;
      }
}